require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-emergency-response-and-nafa-program-support-project.json") })
        }
      }, "path---en-us-project-emergency-response-and-nafa-program-support-project");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-emergency-response-and-nafa-program-support-project!./.cache/json/en-us-project-emergency-response-and-nafa-program-support-project.json
// module id = 504
// module chunks = 231608221292675